import React, { memo } from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import { Spacer } from 'design-system';
import { rem } from 'design-system/values';
import BlurAmountView from 'design-system/BlurAmountView';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import { formatAmount } from 'utils/formatting';
import createStyleSheets from 'utils/createStyleSheets';
import { formatNumberOfShares } from '../utils';
const strings = {
    currentValue: 'Current value',
    numberOfShares: 'No. of shares',
    avgPrice: 'Avg. price per share',
    gainLoss: 'Investment gain/loss',
};
const InfoBlock = (props) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    let number = '';
    let text = '';
    let color = colors.buttons.primary;
    if ('currentValue' in props) {
        number = formatAmount(props.currentValue.value, props.currentValue.currency, 2);
        text = strings.currentValue;
    }
    if ('numberOfShares' in props) {
        number = formatNumberOfShares(props.numberOfShares, false, false);
        text = strings.numberOfShares;
    }
    if ('avgPrice' in props) {
        number = formatAmount(props.avgPrice.value, props.avgPrice.currency, 2);
        text = strings.avgPrice;
    }
    if ('changePercent' in props) {
        const changePercentString = Math.abs(props.changePercent * 100).toFixed(2);
        const changeAmountString = Math.abs(props.changeAmount.value).toFixed(2);
        const zeroString = Number(0).toFixed(2);
        if (changePercentString === zeroString && changeAmountString === zeroString) {
            number = `0.00% (${formatAmount(0, props.changeAmount.currency, 2)})`;
        }
        else if (props.changeAmount.value > 0 || props.changePercent > 0) {
            number = `+${changePercentString.replace(',', '.')}% (${formatAmount(Math.abs(props.changeAmount.value), props.changeAmount.currency, 2)})`;
            color = colors.text.positive;
        }
        else {
            number = `-${changePercentString.replace(',', '.')}% (${formatAmount(Math.abs(props.changeAmount.value), props.changeAmount.currency, 2)})`;
            color = colors.text.negative;
        }
        text = strings.gainLoss;
    }
    return (<View style={styles.container}>
      <View style={styles.infoContainer}>
        <Text TextThin-14 Gray>
          {text}
        </Text>
      </View>
      <Spacer w={16}/>
      <BlurAmountView enabled={scrambled}>
        <Text Numbers-14 color={color}>
          {number}
        </Text>
      </BlurAmountView>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flex: 1,
        flexDirection: 'row',
        paddingVertical: rem(12),
        paddingHorizontal: rem(16),
    },
    number: {
        fontSize: rem(16),
        lineHeight: rem(22),
        fontWeight: '700',
        color: colors.buttons.primary,
    },
    infoContainer: {
        flex: 1,
    },
}));
export default memo(InfoBlock);
